import { render } from "./CreateProxyMintOverview.vue?vue&type=template&id=b728ffe8&scoped=true"
import script from "./CreateProxyMintOverview.vue?vue&type=script&lang=js"
export * from "./CreateProxyMintOverview.vue?vue&type=script&lang=js"

import "./CreateProxyMintOverview.vue?vue&type=style&index=0&id=b728ffe8&lang=css"
import "./CreateProxyMintOverview.vue?vue&type=style&index=1&id=b728ffe8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b728ffe8"]])

export default __exports__